import { useNavigate } from "react-router-dom";
import { LiaArrowRightSolid } from "react-icons/lia";

import MainFooter from "../components/MainFooter";
import MainHeader from "../components/MainHeader";

const ErrorPage = () => {
  const navigate = useNavigate();

  return (
    <>
      <MainHeader />

      <div className="notfound-container">
        <div className="notfound-overlay">
          <h1>Ooops...</h1>
          <h2>Page not found</h2>
          <p>We're sorry, the page you requested could not be found</p>
          <button onClick={() => navigate("/")}>
            Go Back <LiaArrowRightSolid className="fs-1" />
          </button>
        </div>
      </div>

      <MainFooter />
    </>
  );
};

export default ErrorPage;
